import Card from 'react-bootstrap/Card';
import React, { useState, useEffect } from 'react';
import './Card_detail.css' 
function Popupmsg({ Jobseeeker }) {
  const [cardJobseeker, setCardJobseeker] = useState({});
  useEffect(() => {
    if(Jobseeeker && Jobseeeker[0]){
      setCardJobseeker({...Jobseeeker[0]})
    } else{
      setCardJobseeker({...Jobseeeker})
    }
    
  }, [Jobseeeker])

  return (
    <div class="container mx-auto mt-4" style={{paddingLeft:"0px",}}>
      <div className='modal_class' style={{ margin: '0px', padding: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      
      {cardJobseeker.id && <Card className="Card" style={{ width: '17rem' }}>
        <Card.Body className='Card_body'>
          <Card.Subtitle className="  mb-2">Id: {cardJobseeker.id} </Card.Subtitle>
          <Card.Subtitle className="  mb-2">Name: {cardJobseeker.name.first_name}</Card.Subtitle>
          <Card.Subtitle className="  mb-2">Phone no: {cardJobseeker.name.phone}</Card.Subtitle>
          <Card.Subtitle className="  mb-2">Email: {cardJobseeker.name.email}</Card.Subtitle>
        </Card.Body>
      </Card>}

    </div></div>
    


  )
};
export default Popupmsg;